import React from 'react';
import moment from 'moment';
import type { PlusProject } from '../../../models/plus/plusProject';

interface Props {
  project: PlusProject;
}

// Figma の表記どおり開始は2桁年・終了はゼロ埋めなし月
function formatPeriod(startAt: string, finishAt: string): string {
  const start = moment(startAt).format('YY年MM月DD日 HH:mm');
  const finish = moment(finishAt).format('M月DD日 HH:mm');
  return `${start} 〜 ${finish}`;
}

export default function Card({ project }: Props) {
  return (
    <a className="plus-projects-card" href={project.detailPath}>
      <div className="plus-projects-card__image">
        <img src={project.eyecatchUrl} alt={project.title ?? ''} />
      </div>
      <div className="plus-projects-card__body">
        <div className="plus-projects-card__main">
          <div className="plus-projects-card__company">
            <img
              className="plus-projects-card__company-logo"
              src={project.company.imageThumbUrl}
              alt={project.company.name}
            />
            <span className="plus-projects-card__company-name">
              {project.company.name}
            </span>
          </div>
          {project.title && (
            <h2 className="plus-projects-card__title">{project.title}</h2>
          )}
          {project.angelTagLabel && (
            <span className="plus-projects-card__angel-tag">
              {project.angelTagLabel}
            </span>
          )}
        </div>
        <div className="plus-projects-card__footer">
          <hr className="plus-projects-card__divider" />
          <div className="plus-projects-card__period">
            <span className="plus-projects-card__period-label">申込期間</span>
            <span className="plus-projects-card__period-value">
              {formatPeriod(project.startAt, project.finishAt)}
            </span>
          </div>
        </div>
      </div>
    </a>
  );
}
